export default "__VITE_ASSET__BlrQXzxz__"